import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import { Typography } from "@mui/material";

interface TreatmentOtherInfoSymbolProps {
  checked: boolean | null;
}

const TreatmentOtherInfoSymbol = (props: TreatmentOtherInfoSymbolProps) => {
  const { checked } = props;

    if (checked === null) {
    return <Typography>N/A</Typography>;
  }
  return checked ? (
    <CheckCircleIcon fontSize="small" />
  ) : (
    <CancelOutlinedIcon fontSize="small" />
  );
};

export default TreatmentOtherInfoSymbol;
